import { RouterItemType } from "@/app/index";
import { lazy } from "react";

const LayoutPageProfile = lazy(() => import("./layout/index"));

export type LoaderDataProfileType = {
  action: string | null;
};

export const loaderDataProfile = async (args: any) => {
  const url = new URL(args.request.url);
  const action = url.searchParams.get("action");

  return {
    action,
  } as LoaderDataProfileType;
};

export const routerPageProfile: RouterItemType = {
  path: "/profile",
  authorize: true,
  element: <LayoutPageProfile />,
  loader: loaderDataProfile,
};
